import React from 'react';
import { AppBar, Toolbar, Box, Typography, Container } from '@mui/material';
import ruvIcon from '../assets/ruv-logo.svg'; // Stellen Sie sicher, dass der Pfad korrekt ist
import './Header.css';
import { useAppContext } from '../context/AppContext';

function Header() {
  const { state } = useAppContext();
  const mockMode = state.globalConfig?.MOCK_MODE || false;

  return (
    <AppBar
      position="fixed"
      elevation={0}
      className="header-appbar"
      sx={{ backgroundColor: 'white', boxShadow: 'none' }}
    >
      {mockMode && (
        <Typography color="red" style={{ position: 'absolute', left: 0 }}>
          MOCK MODUS
        </Typography>
      )}

      <Toolbar className="header-toolbar">
        <Container className="header-container-wrapper">
          <Box className="header-container">
            {/* Logo links */}
            <Box className="header-logo-container">
              <Box
                component="img"
                src={ruvIcon}
                alt="R+V Logo"
                className="header-logo"
                onError={e => {
                  // Fallback wenn Bild nicht gefunden wird
                  e.target.style.display = 'none';
                }}
              />
            </Box>

            {/* Text mittig */}
            <Box className="header-title-container">
              <Typography component="div" className="header-title">
                Hardwareversicherung
              </Typography>
              <Typography component="div" className="header-subtitle">
                Antrag
              </Typography>
            </Box>

            {/* Rechte Seite für Balance (leer) */}
            <Box className="header-right-spacer" />
          </Box>
        </Container>
      </Toolbar>
    </AppBar>
  );
}

export default Header;
